// extracted by mini-css-extract-plugin
module.exports = {"BirdItem":"BirdItem_BirdItem__3IXiV","success":"BirdItem_success__ruh83","error":"BirdItem_error__1dI2J"};